// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const PlusIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 6c.552 0 1 .474 1 1.059v9.882c0 .585-.448 1.059-1 1.059s-1-.474-1-1.059V7.06c0-.586.448-1.06 1-1.06z"/><path d="M6 12c0-.552.474-1 1.059-1h9.882c.585 0 1.059.448 1.059 1s-.474 1-1.059 1H7.06C6.474 13 6 12.552 6 12z"/></svg>'} />;

(PlusIcon as any).displayName = 'PlusIcon';

export default PlusIcon;
